import { Card, Stack, Typography } from "@mui/joy";
import { SxProps } from "@mui/joy/styles/types";
import { ReactNode } from "react";

type SectionCardProps = {
  title: string;
  icon?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  sx?: SxProps;
};

function SectionCard({ title, icon, action, children, sx }: SectionCardProps) {
  return (
    <Card
      variant="outlined"
      sx={[
        {
          gap: 2,
          p: 2.5,
          borderRadius: "lg",
          boxShadow: "xs",
          backgroundColor: "background.surface",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
        <Stack direction="row" alignItems="center" gap={1.25} sx={{ minWidth: 0 }}>
          {icon && (
            <Stack
              alignItems="center"
              justifyContent="center"
              sx={{
                width: 32,
                height: 32,
                flexShrink: 0,
                borderRadius: "md",
                backgroundColor: "primary.softBg",
                color: "primary.softColor",
                "--Icon-color": "currentColor",
                "--Icon-fontSize": "18px",
              }}
            >
              {icon}
            </Stack>
          )}
          <Typography level="title-md" noWrap>
            {title}
          </Typography>
        </Stack>
        {action}
      </Stack>
      {children}
    </Card>
  );
}

export default SectionCard;
